import axios from 'axios';
import * as config from "../config";

export const COMPANIES_REQUEST= "COMPANIES_REQUEST";
export const COMPANIES_SUCESS= "COMPANIES_SUCESS";
export const COMPANIES_ERROR= "COMPANIES_ERROR";

export function Get() {
    return(dispatch)=>{
        dispatch({
            type:COMPANIES_REQUEST
        });

        axios.get(
            config.apiUrl + "/companies"
        ).then((response)=>{
            dispatch({
                type:COMPANIES_SUCESS,
                payload:response.data
            })
        }).catch((error)=>{
            dispatch({
                type:COMPANIES_ERROR
            })
        })
    }
}


// WEBPACK FOOTER //
// ./src/actions/companiesActions.js